import { render, staticRenderFns } from "./resource-link-wrapper.vue?vue&type=template&id=2a0b1962&scoped=true&"
import script from "./resource-link-wrapper.vue?vue&type=script&lang=js&"
export * from "./resource-link-wrapper.vue?vue&type=script&lang=js&"
import style0 from "./resource-link-wrapper.vue?vue&type=style&index=0&id=2a0b1962&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a0b1962",
  null
  
)

export default component.exports